function config(
	$stateProvider,
	$urlRouterProvider,
	$locationProvider,
	$httpProvider,
	NotificationProvider,
	$provide,
	applicationInsightsServiceProvider
) {
	"use strict";

	// eslint-disable-next-line no-undef
	moment.locale("pt-br");
	$locationProvider.html5Mode(true).hashPrefix("#");
	$urlRouterProvider.when("", "/");
	$urlRouterProvider.otherwise("/error");
	$stateProvider
		.state("home", {
			cache: false,
			url: "/?menu",
			templateUrl: "views/newAngular/home/home-page/homePage.html",
			isFree: true,
			newSingleton: true
		})
		.state("homeSupplier", {
			cache: false,
			url: "/inicio-fornecedor",
			templateUrl: "views/newAngular/home/home-page/homePage.html",
			isFree: true,
			newSingleton: true
		})
		.state("outdatedVersion", {
			url: "/atualizando",
			templateUrl: "views/architectural/outdatedVersion/outdatedVersion.html",
			noAuth: true,
			newSingleton: false
		})
		.state("error", {
			url: "/erro",
			templateUrl: "views/architectural/error/error.html",
			isFree: true,
			newSingleton: false
		})
		.state("blockedPage", {
			url: "/upgrade",
			templateUrl: "views/architectural/blockedPage/blockedPage_template.html",
			isFree: true,
			newSingleton: false
		})
		//---------------------------------------------------------------------------------------------------//
		///////////////////////////////////////////LOGIN AND ACCOUNT///////////////////////////////////////////
		//---------------------------------------------------------------------------------------------------//
		.state("changeTemporaryPassword", {
			url: "/alterar-senha",
			templateUrl: "views/register/changeTemporaryPassword.html",
			noPadding: true,
			isFree: true,
			newSingleton: false
		})
		.state("completeSignup", {
			url: "/completar-cadastro",
			templateUrl: "views/register/completeSignUp.html",
			noPadding: true,
			isFree: true,
			newSingleton: false
		})
		.state("login", {
			url: "/login?username&error&showBack",
			templateUrl: "views/login/login.html",
			noPadding: true,
			isFree: true,
			noAuth: true,
			newSingleton: false
		})
		.state("chooseLogin", {
			url: "/login-sso?idp&error&appLogin&showOnlySSO",
			templateUrl: "views/login/loginOptions.html",
			noPadding: true,
			isFree: true,
			noAuth: true,
			newSingleton: false
		})
		.state("forgottenPassword", {
			url: "/resetar",
			templateUrl: "views/login/forgottenPassword.html",
			noPadding: true,
			isFree: true,
			noAuth: true,
			newSingleton: false
		})
		.state("resetPassword", {
			url: "/nova-senha",
			templateUrl: "views/login/resetPassword.html",
			noPadding: true,
			isFree: true,
			noAuth: true,
			forceLogout: true,
			params: {
				username: null
			},
			newSingleton: false
		})
		.state("afterLoginIdentityProvider", {
			url: "/autenticacao",
			templateUrl: "views/afterLoginIdentityProvider/afterLoginIdentityProvider.html",
			isFree: true,
			newSingleton: false
		})
		.state("loginResponse", {
			url: "/login-response",
			templateUrl: "views/afterLoginIdentityProvider/loginResponse.html",
			isFree: true,
			noAuth: true,
			newSingleton: false
		})
		//---------------------------------------------------------------------------------------------------//
		///////////////////////////////////////////LOGIN AND ACCOUNT///////////////////////////////////////////
		//---------------------------------------------------------------------------------------------------//
		//---------------------------------------------------------------------------------------------------//
		////////////////////////////////////////////////SYSTEM/////////////////////////////////////////////////
		//---------------------------------------------------------------------------------------------------//
		.state("featureToggleList", {
			url: "/master/feature-toggles",
			templateUrl: "views/newAngular/master/featureToggles/list/featureToggleList.html",
			isMaster: true,
			getAccess: function (userAccessService) {
				return userAccessService.getAccess(Vgr.systemPermissions.MasterViewFeatureToggles);
			},
			newSingleton: true
		})
		.state("featureToggleEdit", {
			url: "/master/feature-toggle/:id",
			templateUrl: "views/newAngular/master/featureToggles/edit/featureToggleEdit.html",
			isMaster: true,
			getAccess: function (userAccessService) {
				return userAccessService.getAccess(Vgr.systemPermissions.MasterViewFeatureToggles);
			},
			newSingleton: true
		})
		.state("auditTrailList", {
			url: "/master/historico-alteracoes",
			templateUrl: "views/newAngular/master/auditTrail/auditTrailList.html",
			isMaster: true,
			getAccess: function (userAccessService) {
				return userAccessService.getAccess(Vgr.systemPermissions.MasterExecuteAdminActions);
			},
			newSingleton: true
		})
		//---------------------------------------------------------------------------------------------------//
		////////////////////////////////////////////////SYSTEM/////////////////////////////////////////////////
		//---------------------------------------------------------------------------------------------------//
		//---------------------------------------------------------------------------------------------------//
		/////////////////////////////////////////////RESIDUE MARKET////////////////////////////////////////////
		//---------------------------------------------------------------------------------------------------//
		.state("residueMarketNew", {
			url: "/mercado/home",
			templateUrl: "views/newAngular/residueMarket/residueMarketHome.html",
			noPadding: true,
			isFree: true,
			newSingleton: true
		})
		.state("residueMarketIndicationRequestRedirect", {
			url: "/mercado/redirect",
			templateUrl: "views/newAngular/residueMarket/residueMarketRedirect.html",
			noPadding: true,
			isFree: true,
			newSingleton: true
		})
		.state("residueMarketIndicationRequestCreateProspective", {
			url: "/mercado/criar-solicitacao-prospect",
			templateUrl: "views/newAngular/residueMarket/indicationRequest/indicationRequestProspectiveCreate.html",
			noPadding: true,
			isFree: true,
			newSingleton: true
		})
		.state("residueMarketIndicationRequestCreate", {
			url: "/mercado/criar-solicitacao",
			templateUrl: "views/newAngular/residueMarket/indicationRequest/indicationRequestCreate.html",
			noPadding: true,
			isFree: true,
			newSingleton: true
		})
		.state("residueMarketIndicationRequestEdit", {
			url: "/mercado/solicitacao-indicacao/:id",
			templateUrl: "views/newAngular/residueMarket/indicationRequest/indicationRequestEdit.html",
			noPadding: true,
			isFree: true,
			newSingleton: true
		})
		.state("residueMarketBackOfficeSupplierListGeneration", {
			url: "/mercado/back-office/quadro-de-demanda",
			templateUrl: "views/newAngular/residueMarket/backOffice/supplierListGeneration.html",
			noPadding: true,
			isMaster: true,
			getAccess: function (userAccessService) {
				return userAccessService.getAccess(Vgr.systemPermissions.MasterViewClientData);
			},
			newSingleton: true
		})
		.state("residueMarketBackOfficeSuccess", {
			url: "/mercado/back-office/sucesso",
			templateUrl: "views/newAngular/residueMarket/backOffice/residueMarketSuccess.html",
			noPadding: true,
			isMaster: true,
			getAccess: function (userAccessService) {
				return userAccessService.getAccess(Vgr.systemPermissions.MasterViewClientData);
			},
			newSingleton: true
		})
		.state("residueMarketBackOfficeListSupplierByRegion", {
			url: "/mercado/back-office/fornecedores-por-regiao",
			templateUrl: "views/newAngular/residueMarket/backOffice/listSupplierByRegion.html",
			noPadding: true,
			isMaster: true,
			getAccess: function (userAccessService) {
				return userAccessService.getAccess(Vgr.systemPermissions.MasterViewClientData);
			},
			newSingleton: true
		})
		//---------------------------------------------------------------------------------------------------//
		/////////////////////////////////////////////RESIDUE MARKET////////////////////////////////////////////
		//---------------------------------------------------------------------------------------------------//
		//---------------------------------------------------------------------------------------------------//
		/////////////////////////////////////////////SUPPLIER VIEW/////////////////////////////////////////////
		//---------------------------------------------------------------------------------------------------//
		.state("supplierDashboard", {
			url: "/fornecedor/visao-geral?tab&utmSource&abrirPainel",
			templateUrl: "views/newAngular/supplierView/supplierDashboard/supplierDashboard.html",
			isFree: true,
			newSingleton: true
		})
		.state("documentEdit", {
			url: "/fornecedor/documento/:documentId?documentRequestId",
			templateUrl: "views/newAngular/supplierView/documents/documentEdit.html",
			isFree: true,
			newSingleton: true
		})
		.state("documentCreate", {
			url: "/fornecedor/documento?documentType&documentRequestId",
			templateUrl: "views/newAngular/supplierView/documents/documentCreate.html",
			isFree: true,
			newSingleton: true
		})
		.state("supplierViewCollectionRequestList", {
			url: "/fornecedor/gestao-solicitacoes",
			templateUrl: "views/newAngular/supplierView/collectionRequests/supplierViewCollectionRequestList.html",
			isFree: true,
			newSingleton: true
		})
		.state("supplierViewCollectionRequestDisposalEdit", {
			url: "/fornecedor/gestao-solicitacoes/destinacao/:id",
			templateUrl: "views/newAngular/supplierView/collectionRequests/supplierViewCollectionRequestDisposalEdit.html",
			isFree: true,
			newSingleton: true
		})
		.state("supplierViewCollectionRequestEquipmentEdit", {
			url: "/fornecedor/gestao-solicitacoes/equipamento/:id",
			templateUrl: "views/newAngular/supplierView/collectionRequests/supplierViewCollectionRequestEquipmentEdit.html",
			isFree: true,
			newSingleton: true
		})
		//---------------------------------------------------------------------------------------------------//
		/////////////////////////////////////////////SUPPLIER VIEW/////////////////////////////////////////////
		//---------------------------------------------------------------------------------------------------//
		//---------------------------------------------------------------------------------------------------//
		////////////////////////////////////////////////SUPPLIERS//////////////////////////////////////////////
		//---------------------------------------------------------------------------------------------------//
		.state("supplierList", {
			url: "/organizacao/fornecedores?pendencia&unidade&vincular&utmSource",
			templateUrl: "views/newAngular/suppliers/list/supplierList.html",
			newSingleton: true
		})
		.state("supplierCreate", {
			url: "/organizacao/cadastrar-fornecedor",
			templateUrl: "views/newAngular/suppliers/create/supplierCreate.html",
			newSingleton: true
		})
		.state("supplierEdit", {
			url: "/organizacao/fornecedores/:id?tab&openCreateDocument&disposalModelId&utmSource",
			templateUrl: "views/newAngular/suppliers/edit/supplierEdit.html",
			newSingleton: true
		})
		.state("newOrganizationAuthDocument", {
			url: "/organizacao/fornecedores/:supplierCode/documento?docType&supDocId&requestId&replacedDocumentId&originFilePath&description&number&initialDate&expirationDate&protocolNumber&protocolDate",
			templateUrl: "views/newAngular/suppliers/documents/create/createAuthDocument.html",
			newSingleton: true
		})
		.state("editSupplierDocument", {
			url: "/organizacao/fornecedores/:supplierCode/documento/:docId?supDocId&requestId",
			templateUrl: "views/newAngular/suppliers/documents/edit/editAuthDocument.html",
			newSingleton: true
		})
		.state("editSupplierContact", {
			url: "/organizacao/fornecedores/:supplierCode/contato/:contactId?supplierId",
			templateUrl: "views/newAngular/suppliers/contact/edit/editContact.html",
			newSingleton: true
		})
		.state("createSupplierContact", {
			url: "/organizacao/fornecedores/:supplierCode/contato?supplierId",
			templateUrl: "views/newAngular/suppliers/contact/create/createContact.html",
			newSingleton: true
		})
		.state("editSupplierTransporterVehicle", {
			url: "/organizacao/fornecedores/:supplierCode/veiculo/:vehicleId?supplierId",
			templateUrl: "views/newAngular/suppliers/vehicle/edit/editVehicle.html",
			newSingleton: true
		})
		.state("createSupplierTransporterVehicle", {
			url: "/organizacao/fornecedores/:supplierCode/veiculo?supplierId",
			templateUrl: "views/newAngular/suppliers/vehicle/create/createVehicle.html",
			newSingleton: true
		})
		.state("editSupplierTransporterDriver", {
			url: "/organizacao/fornecedores/:supplierCode/condutor/:driverId?supplierId",
			templateUrl: "views/newAngular/suppliers/driver/edit/editDriver.html",
			newSingleton: true
		})
		.state("createSupplierTransporterDriver", {
			url: "/organizacao/fornecedores/:supplierCode/condutor?supplierId",
			templateUrl: "views/newAngular/suppliers/driver/create/createDriver.html",
			newSingleton: true
		})
		.state("listDocumentType", {
			url: "/organizacao/fornecedores/tipos-documento",
			templateUrl: "views/newAngular/suppliers/documentTypes/listDocumentType.html",
			newSingleton: true
		})
		.state("listSupplierProfile", {
			url: "/organizacao/fornecedores/perfis",
			templateUrl: "views/newAngular/suppliers/profiles/listSupplierProfile.html",
			newSingleton: true
		})
		.state("editDocumentType", {
			url: "/organizacao/fornecedores/tipos-documento/:id",
			templateUrl: "views/newAngular/suppliers/documentTypes/editDocumentType.html",
			newSingleton: true
		})
		.state("editSupplierProfile", {
			url: "/organizacao/fornecedores/perfis/:id",
			templateUrl: "views/newAngular/suppliers/profiles/editSupplierProfile.html",
			newSingleton: true
		})
		.state("listAuditModel", {
			url: "/organizacao/fornecedores/modelos-auditoria?success",
			templateUrl: "views/newAngular/suppliers/auditModels/list/auditModel.html",
			newSingleton: true
		})
		.state("createEditAuditModel", {
			url: "/organizacao/fornecedores/modelo-auditoria?id",
			templateUrl: "views/newAngular/suppliers/auditModels/edit/auditModelCreateEdit.html",
			newSingleton: true
		})
		.state("createSupplierAudit", {
			url: "/organizacao/fornecedores/:supplierCode/auditoria",
			templateUrl: "views/newAngular/suppliers/audit/create/createAudit.html",
			isFree: true,
			newSingleton: true
		})
		.state("editSupplierAudit", {
			url: "/organizacao/fornecedores/:supplierCode/auditoria/:auditId?tab&isSupplierView",
			templateUrl: "views/newAngular/suppliers/audit/edit/editAudit.html",
			isFree: true,
			newSingleton: true
		})
		.state("createSupplierActionPlan", {
			url: "/organizacao/fornecedores/:supplierCode/plano-de-acao?auditId",
			templateUrl: "views/newAngular/suppliers/actionPlan/create/createActionPlan.html",
			isFree: true,
			newSingleton: true
		})
		.state("editSupplierActionPlan", {
			url: "/organizacao/fornecedores/:supplierCode/plano-de-acao/:actionPlanId?pendente&isSupplierView",
			templateUrl: "views/newAngular/suppliers/actionPlan/edit/editActionPlan.html",
			isFree: true,
			newSingleton: true
		})
		.state("documentRequestList", {
			url: "/organizacao/solicitacoes-de-documento",
			templateUrl: "views/newAngular/suppliers/documents/requests/documentRequestList.html",
			newSingleton: true
		})
		.state("createSupplierMonitoring", {
			url: "/organizacao/fornecedores/monitoramento?supplierId",
			templateUrl: "views/newAngular/suppliers/monitoring/create/createSupplierMonitoring.html",
			newSingleton: true
		})
		.state("editSupplierMonitoring", {
			url: "/organizacao/fornecedores/:supplierCode/monitoramento/:monitoringId",
			templateUrl: "views/newAngular/suppliers/monitoring/edit/editSupplierMonitoring.html",
			newSingleton: true
		})
		//---------------------------------------------------------------------------------------------------//
		///////////////////////////////////////////////SUPPLIERS///////////////////////////////////////////////
		//---------------------------------------------------------------------------------------------------//
		//---------------------------------------------------------------------------------------------------//
		//////////////////////////////////////////////ONBOARDING///////////////////////////////////////////////
		//---------------------------------------------------------------------------------------------------//
		.state("accountEdit", {
			url: "/meus-dados",
			templateUrl: "views/newAngular/onboarding/users/editAccount.html",
			isFree: true,
			newSingleton: true
		})
		.state("masterUserList", {
			url: "/master/usuarios",
			templateUrl: "views/newAngular/master/users/list/masterUserList.html",
			isMaster: true,
			getAccess: function (userAccessService) {
				return getStandardMasterAccess(userAccessService);
			},
			newSingleton: true
		})
		.state("masterUserEdit", {
			url: "/master/usuarios/:id",
			templateUrl: "views/newAngular/master/users/edit/masterUserEdit.html",
			isMaster: true,
			getAccess: function (userAccessService) {
				return getStandardMasterAccess(userAccessService);
			},
			newSingleton: true
		})
		.state("masterPlanList", {
			url: "/master/planos",
			templateUrl: "views/newAngular/master/organizations/plansList.html",
			isMaster: true,
			getAccess: function (userAccessService) {
				return userAccessService.getAccess(Vgr.systemPermissions.MasterExecuteAdminActions);
			},
			newSingleton: true
		})
		.state("masterPlanEdit", {
			url: "/master/plano/:id",
			templateUrl: "views/newAngular/master/organizations/planEdit.html",
			isMaster: true,
			getAccess: function (userAccessService) {
				return userAccessService.getAccess(Vgr.systemPermissions.MasterExecuteAdminActions);
			},
			newSingleton: true
		})
		.state("masterOrganizationList", {
			url: "/master/organizacoes",
			templateUrl: "views/newAngular/master/organizations/masterOrganizationList.html",
			isMaster: true,
			getAccess: function (userAccessService) {
				return getStandardMasterAccess(userAccessService);
			},
			newSingleton: true
		})
		.state("masterOrganizationEdit", {
			url: "/master/organizacao/:id",
			templateUrl: "views/newAngular/master/organizations/masterOrganizationEdit.html",
			isMaster: true,
			getAccess: function (userAccessService) {
				return getStandardMasterAccess(userAccessService);
			},
			newSingleton: true
		})
		.state("masterPermissionGroupList", {
			url: "/master/grupos-de-permissao",
			templateUrl: "views/newAngular/master/permissionGroups/masterPermissionGroupList.html",
			isMaster: true,
			getAccess: function (userAccessService) {
				return userAccessService.getAccess(Vgr.systemPermissions.MasterPermissionManagement);
			},
			newSingleton: true
		})
		.state("masterPermissionGroupEdit", {
			url: "/master/grupos-de-permissao/:id",
			templateUrl: "views/newAngular/master/permissionGroups/masterPermissionGroupEdit.html",
			isMaster: true,
			getAccess: function (userAccessService) {
				return userAccessService.getAccess(Vgr.systemPermissions.MasterPermissionManagement);
			},
			newSingleton: true
		})
		.state("organizationGeneralData", {
			url: "/organizacao?tab",
			templateUrl: "views/newAngular/onboarding/organizations/organizationEdit.html",
			isFree: true,
			newSingleton: true
		})
		.state("unitList", {
			url: "/organizacao/unidades",
			templateUrl: "views/newAngular/onboarding/organizationUnits/organizationUnitList.html",
			isFree: true,
			newSingleton: true
		})
		.state("unitEdit", {
			url: "/organizacao/unidades/editar/:id?tab",
			templateUrl: "views/newAngular/onboarding/organizationUnits/organizationUnitEdit.html",
			isFree: true,
			newSingleton: true
		})
		.state("organizationAdditionalPropertiesList", {
			url: "/organizacao/informacoes-adicionais",
			templateUrl: "views/newAngular/onboarding/properties/list/propertiesList.html",
			newSingleton: true
		})
		.state("organizationAdditionalPropertiesEdit", {
			url: "/organizacao/propriedades/:id",
			templateUrl: "views/newAngular/onboarding/properties/propertiesEdit.html",
			newSingleton: true
		})
		.state("residueOrganizationList", {
			url: "/organizacao/residuos",
			templateUrl: "views/newAngular/onboarding/residues/list/residuesList.html",
			newSingleton: true
		})
		.state("organizationResidueEdit", {
			url: "/organizacao/residuos/:id",
			templateUrl: "views/newAngular/onboarding/residues/edit/residueEdit.html",
			newSingleton: true
		})
		.state("areaOrganizationList", {
			url: "/organizacao/areas",
			templateUrl: "views/newAngular/onboarding/areas/list/areaList.html",
			newSingleton: true
		})
		.state("userList", {
			url: "/organizacao/usuarios",
			templateUrl: "views/newAngular/onboarding/users/userList.html",
			isFree: true,
			newSingleton: true
		})
		.state("userPermissions", {
			url: "/organizacao/usuarios/:id/permissoes",
			templateUrl: "views/newAngular/onboarding/users/userPermissions.html",
			isFree: true,
			newSingleton: true
		})
		.state("organizationPermissionList", {
			url: "/organizacao/perfis-acesso",
			templateUrl: "views/newAngular/onboarding/permissions/list/permissionGroupList.html",
			newSingleton: true
		})
		.state("organizationPermissionEdit", {
			url: "/organizacao/perfis-acesso/:id",
			templateUrl: "views/newAngular/onboarding/permissions/edit/organizationPermissionGroupEdit.html",
			newSingleton: true
		})
		.state("mtrIntegrationList", {
			url: "/organizacao/integracoes?tab",
			templateUrl: "views/newAngular/onboarding/mtr-integrations/mtrIntegrationList.html",
			newSingleton: true
		})
		.state("mtrExemptionCreate", {
			url: "/organizacao/integracoes/desobrigacao-mtr/novo",
			templateUrl: "views/newAngular/onboarding/mtr-integrations/mtrExemptionCreate.html",
			newSingleton: true
		})
		.state("mtrSystemLoginCreate", {
			url: "/organizacao/integracoes/login/novo",
			templateUrl: "views/newAngular/onboarding/mtr-integrations/mtrSystemLoginCreate.html",
			newSingleton: true
		})
		.state("mtrSystemLoginEdit", {
			url: "/organizacao/integracoes/login/:id",
			templateUrl: "views/newAngular/onboarding/mtr-integrations/mtrSystemLoginEdit.html",
			newSingleton: true
		})
		.state("residueList", {
			url: "/unidade/residuos",
			templateUrl: "views/newAngular/onboarding/residues/list/organizationUnitResidueList.html",
			newSingleton: true
		})
		.state("residueEdit", {
			url: "/unidade/residuo/:residueCode?tab",
			templateUrl: "views/newAngular/onboarding/residues/edit/organizationUnitResidueEdit.html",
			newSingleton: true
		})
		.state("recipientList", {
			url: "/unidade/acondicionamentos",
			templateUrl: "views/newAngular/onboarding/recipients/list/recipientList.html",
			newSingleton: true
		})
		.state("recipientEdit", {
			url: "/unidade/acondicionamento/:id",
			templateUrl: "views/newAngular/onboarding/recipients/edit/recipientEdit.html",
			newSingleton: true
		})
		.state("unitAreaList", {
			url: "/unidade/areas",
			templateUrl: "views/newAngular/onboarding/areas/list/organizationUnitAreaList.html",
			newSingleton: true
		})
		.state("unitAreaEdit", {
			url: "/unidade/area/:id",
			templateUrl: "views/newAngular/onboarding/areas/edit/areaEdit.html",
			newSingleton: true
		})
		.state("costCenterList", {
			url: "/organizacao/centros-de-custo",
			templateUrl: "views/newAngular/onboarding/cost-centers/costCenterList.html",
			newSingleton: true
		})
		.state("costCenterEdit", {
			url: "/organizacao/centro-de-custo/:id",
			templateUrl: "views/newAngular/onboarding/cost-centers/costCenterEdit.html",
			newSingleton: true
		})
		.state("unitPermissionList", {
			url: "/unidade/perfis-acesso",
			templateUrl: "views/newAngular/onboarding/permissions/list/organizationUnitPermissionGroupList.html",
			newSingleton: true
		})
		.state("unitPermissionEdit", {
			url: "/unidade/perfis-acesso/:id",
			templateUrl: "views/newAngular/onboarding/permissions/edit/organizationUnitPermissionGroupEdit.html",
			newSingleton: true
		})
		.state("productEdit", {
			url: "/unidade/produto/:id",
			templateUrl: "views/newAngular/onboarding/processes/products/edit/productEdit.html",
			newSingleton: true
		})
		.state("productList", {
			url: "/unidade/produtos",
			templateUrl: "views/newAngular/onboarding/processes/products/list/productList.html",
			newSingleton: true
		})
		.state("rawMaterialList", {
			url: "/unidade/materias-primas",
			templateUrl: "views/newAngular/onboarding/processes/rawMaterials/list/rawMaterialList.html",
			newSingleton: true
		})
		.state("rawMaterialEdit", {
			url: "/unidade/materia-prima/:id",
			templateUrl: "views/newAngular/onboarding/processes/rawMaterials/edit/rawMaterialEdit.html",
			newSingleton: true
		})
		.state("processStepList", {
			url: "/unidade/etapas",
			templateUrl: "views/newAngular/onboarding/processes/processSteps/list/processStepList.html",
			newSingleton: true
		})
		.state("processStepEdit", {
			url: "/unidade/etapa/:id",
			templateUrl: "views/newAngular/onboarding/processes/processSteps/edit/processStepEdit.html",
			newSingleton: true
		})
		.state("processList", {
			url: "/unidade/processos",
			templateUrl: "views/newAngular/onboarding/processes/processes/list/processList.html",
			newSingleton: true
		})
		.state("processEdit", {
			url: "/unidade/processo/:id",
			templateUrl: "views/newAngular/onboarding/processes/processes/edit/processEdit.html",
			newSingleton: true
		})
		.state("emailRequestList", {
			url: "/organizacao/emails",
			templateUrl: "views/newAngular/onboarding/emails/emailRequestList.html",
			newSingleton: true
		})
		.state("equipmentList", {
			url: "/unidade/equipamentos",
			templateUrl: "views/newAngular/onboarding/equipments/list/equipmentList.html",
			newSingleton: true
		})
		.state("equipmentEdit", {
			url: "/unidade/equipamento/:id",
			templateUrl: "views/newAngular/onboarding/equipments/edit/equipmentEdit.html",
			newSingleton: true
		})
		.state("organizationUnitDocumentList", {
			url: "/unidade/documentos",
			templateUrl: "views/newAngular/onboarding/organizationUnitDocuments/organizationUnitDocumentList.html",
			newSingleton: true,
			isFree: true
		})
		.state("organizationUnitDocumentEdit", {
			url: "/unidade/documento/:id",
			templateUrl: "views/newAngular/onboarding/organizationUnitDocuments/organizationUnitDocumentEdit.html",
			newSingleton: true,
			isFree: true
		})
		//---------------------------------------------------------------------------------------------------//
		//////////////////////////////////////////////ONBOARDING///////////////////////////////////////////////
		//---------------------------------------------------------------------------------------------------//
		//---------------------------------------------------------------------------------------------------//
		/////////////////////////////////////////////////BI////////////////////////////////////////////////////
		//---------------------------------------------------------------------------------------------------//
		.state("customReport", {
			url: "/bi/relatorios",
			templateUrl: "views/newAngular/bi/custom-report/customReport.html",
			newSingleton: true
		})
		.state("pgrs", {
			url: "/declaracoes/pgrs",
			templateUrl: "views/newAngular/bi/pgrs/pgrsList.html",
			getAccess: function (userAccessService, featureAccessService) {
				return getPgrsAccess(userAccessService, featureAccessService);
			},
			newSingleton: true,
			isFree: true
		})
		.state("editPgrs", {
			url: "/declaracoes/pgrs/:pgrsId/editar",
			templateUrl: "views/newAngular/bi/pgrs/pgrsEdit.html",
			getAccess: function (userAccessService, featureAccessService) {
				return getPgrsAccess(userAccessService, featureAccessService);
			},
			newSingleton: true,
			isFree: true
		})
		.state("editMaturity", {
			url: "/bi/eficiencia-ambiental",
			templateUrl: "views/newAngular/bi/maturity/editMaturity.html",
			getAccess: function (userAccessService) {
				const hasMasterViewPermission = userAccessService.hasAccess(Vgr.systemPermissions.MasterViewClientData);
				const hasFeatureAccess = userAccessService.hasAccess(
					Vgr.systemPermissions.MaturityView,
					null,
					Vgr.constants.featureToggles.release.maturityModule
				);

				return hasFeatureAccess || hasMasterViewPermission
					? Vgr.enumerations.userAccess.Enabled
					: Vgr.enumerations.userAccess.Hidden;
			},
			newSingleton: true
		})
		.state("editMaturityAnswer", {
			url: "/bi/eficiencia-ambiental/itens/:questionId/editar",
			templateUrl: "views/newAngular/bi/maturity/maturityAnswerEdit.html",
			getAccess: function (userAccessService) {
				const hasMasterViewPermission = userAccessService.hasAccess(Vgr.systemPermissions.MasterViewClientData);
				const hasFeatureAccess = userAccessService.hasAccess(
					Vgr.systemPermissions.MaturityView,
					null,
					Vgr.constants.featureToggles.release.maturityModule
				);

				return hasFeatureAccess || hasMasterViewPermission
					? Vgr.enumerations.userAccess.Enabled
					: Vgr.enumerations.userAccess.Hidden;
			},
			newSingleton: true
		})
		.state("customReportCreate", {
			url: "/bi/relatorios/novo",
			templateUrl: "views/newAngular/bi/custom-report/customReportCreate.html",
			newSingleton: true
		})
		.state("customReportEdit", {
			url: "/bi/relatorios/:reportId",
			templateUrl: "views/newAngular/bi/custom-report/customReportEdit.html",
			newSingleton: true
		})
		.state("genericKpiReport", {
			url: "/bi/relatorios/kpi",
			templateUrl: "views/newAngular/bi/custom-report/genericKpiReport.html",
			newSingleton: true
		})
		.state("relativeKpis", {
			url: "/bi/relatorios/kpi-relativo",
			templateUrl: "views/newAngular/bi/custom-report/relativeKpis.html",
			newSingleton: true
		})
		.state("cadriBalanceReport", {
			url: "/bi/relatorios/saldo-cadri",
			templateUrl: "views/newAngular/bi/legacy-reports/cadriBalanceReport.html",
			newSingleton: true
		})
		.state("generatingManagementInventoryReport", {
			url: "/bi/relatorios/inventario-gerencial",
			templateUrl: "views/newAngular/bi/legacy-reports/managementInventoryReport.html",
			newSingleton: true
		})
		.state("residueMovimentationReport", {
			url: "/bi/relatorios/movimentacao-residuos",
			templateUrl: "views/newAngular/bi/legacy-reports/movimentationReport.html",
			newSingleton: true
		})
		.state("residueTraceabilityReport", {
			url: "/bi/relatorios/rastreabilidade-residuos",
			templateUrl: "views/newAngular/bi/reports/residueTraceabilityReport.html",
			newSingleton: true
		})
		.state("disposalCollectionRequestReport", {
			url: "/bi/relatorios/destinacoes-com-solicitacoes",
			templateUrl: "views/newAngular/bi/reports/disposalCollectionRequestReport.html",
			newSingleton: true
		})
		.state("executiveReportSuppliers", {
			url: "/bi/relatorios/executivo-fornecedores",
			templateUrl: "views/newAngular/bi/reports/executiveReportSuppliers.html",
			newSingleton: true
		})
		.state("bi", {
			url: "/bi?tab",
			templateUrl: "views/newAngular/bi/powerbi/embed-powerbi.html",
			newSingleton: true
		})
		//---------------------------------------------------------------------------------------------------//
		/////////////////////////////////////////////////BI////////////////////////////////////////////////////
		//---------------------------------------------------------------------------------------------------//
		//---------------------------------------------------------------------------------------------------//
		/////////////////////////////////////////////////ESG///////////////////////////////////////////////////
		//---------------------------------------------------------------------------------------------------//
		.state("esgEmbedPowerbi", {
			url: "/painel-de-emissoes",
			templateUrl: "views/newAngular/bi/powerbi/esgEmbedPowerbi.html",
			newSingleton: true
		})
		//---------------------------------------------------------------------------------------------------//
		/////////////////////////////////////////////////ESG///////////////////////////////////////////////////
		//---------------------------------------------------------------------------------------------------//
		//---------------------------------------------------------------------------------------------------//
		////////////////////////////////////////EQUIPMENT ALLOCATION////////////////////////////////////////////
		//---------------------------------------------------------------------------------------------------//
		.state("equipmentAllocationList", {
			url: "/alocacao-equipamentos",
			templateUrl: "views/newAngular/equipmentAllocation/equipmentAllocationList.html",
			getAccess: function (userAccessService) {
				return userAccessService.getAccess(
					Vgr.systemPermissions.EquipmentAllocationView,
					null,
					Vgr.constants.featureToggles.release.collectionRequestDisposal
				);
			},
			newSingleton: true
		})
		.state("equipmentAllocationDetail", {
			url: "/alocacao-equipamentos/:id",
			templateUrl: "views/newAngular/equipmentAllocation/equipmentAllocationDetail.html",
			getAccess: function (userAccessService) {
				return userAccessService.getAccess(
					Vgr.systemPermissions.EquipmentAllocationView,
					null,
					Vgr.constants.featureToggles.release.collectionRequestDisposal
				);
			},
			newSingleton: true
		})
		.state("equipmentAllocationCreate", {
			url: "/alocacao-equipamentos/nova",
			templateUrl: "views/newAngular/equipmentAllocation/equipmentAllocationCreate.html",
			getAccess: function (userAccessService) {
				return userAccessService.getAccess(
					Vgr.systemPermissions.CrudEquipmentAllocation,
					null,
					Vgr.constants.featureToggles.release.collectionRequestDisposal
				);
			},
			newSingleton: true
		})
		//---------------------------------------------------------------------------------------------------//
		////////////////////////////////////////EQUIPMENT ALLOCATION////////////////////////////////////////////
		//---------------------------------------------------------------------------------------------------//
		//---------------------------------------------------------------------------------------------------//
		/////////////////////////////////////////////DECLARATIONS//////////////////////////////////////////////
		//---------------------------------------------------------------------------------------------------//
		.state("dnitReport", {
			url: "/declaracoes/dnit",
			templateUrl: "views/newAngular/residuesManagement/declarations/dnitReport.html",
			getAccess: function (_userAccessService, featureAccessService) {
				return featureAccessService.hasDnitIntegrationFeature()
					? Vgr.enumerations.userAccess.Enabled
					: Vgr.enumerations.userAccess.Hidden;
			},
			newSingleton: true
		})
		.state("conamaInvetoryReport", {
			url: "/declaracoes/conama313",
			templateUrl: "views/newAngular/residuesManagement/declarations/conama313Report.html",
			newSingleton: true
		})
		.state("ibamaReport", {
			url: "/declaracoes/ibama-rapp/relatorio",
			templateUrl: "views/newAngular/residuesManagement/declarations/ibamaRappReport.html",
			newSingleton: true
		})
		.state("ibamaRappCreate", {
			url: "/declaracoes/ibama-rapp/integracao/novo",
			templateUrl: "views/newAngular/residuesManagement/declarations/ibamaRappIntegrationCreate.html",
			getAccess: function (userAccessService, featureAccessService) {
				return getIbamaRappIntegrationCreateAccess(userAccessService, featureAccessService);
			},
			newSingleton: true
		})
		.state("ibamaRappList", {
			url: "/declaracoes/ibama-rapp/integracao/",
			templateUrl: "views/newAngular/residuesManagement/declarations/ibamaRappIntegration.html",
			getAccess: function (userAccessService, featureAccessService) {
				return getIbamaRappIntegrationViewAccess(userAccessService, featureAccessService);
			},
			newSingleton: true
		})
		.state("ibamaRappFollowup", {
			url: "/declaracoes/ibama-rapp/integracao/acompanhamento/:id",
			templateUrl: "views/newAngular/residuesManagement/declarations/ibamaRappIntegrationFollowup.html",
			getAccess: function (userAccessService, featureAccessService) {
				return getIbamaRappIntegrationViewAccess(userAccessService, featureAccessService);
			},
			newSingleton: true
		})
		.state("dmrReport", {
			url: "/declaracoes/dmr",
			templateUrl: "views/newAngular/residuesManagement/declarations/dmrReport.html",
			getAccess: function (userAccessService) {
				return userAccessService.getAccess(Vgr.systemPermissions.ViewDeclarations);
			},
			newSingleton: true
		})
		//---------------------------------------------------------------------------------------------------//
		/////////////////////////////////////////////DECLARATIONS//////////////////////////////////////////////
		//---------------------------------------------------------------------------------------------------//
		.state("collectionRequestDisposalCreate", {
			url: "/gestao-solicitacoes/destinacao/nova",
			templateUrl:
				"views/newAngular/residuesManagement/collectionRequests/disposals/collectionRequestDisposalCreate.html",
			getAccess: function (userAccessService) {
				return userAccessService.getAccess(
					Vgr.systemPermissions.CrudCollectionRequestDisposal,
					null,
					Vgr.constants.featureToggles.release.collectionRequestDisposal
				);
			},
			newSingleton: true
		})
		.state("collectionRequestInternalTransferCreate", {
			url: "/gestao-solicitacoes/transferencia-interna/nova?geracao",
			templateUrl:
				"views/newAngular/residuesManagement/collectionRequests/internalTransfers/collectionRequestInternalTransferCreate.html",
			getAccess: function (userAccessService) {
				return userAccessService.getAccess(
					Vgr.systemPermissions.RequestInternalTransfer,
					null,
					Vgr.constants.featureToggles.release.collectionRequestInternalTransfer
				);
			},
			newSingleton: true
		})
		.state("collectionRequestEquipmentCreate", {
			url: "/gestao-solicitacoes/equipamento/nova",
			templateUrl:
				"views/newAngular/residuesManagement/collectionRequests/equipments/collectionRequestEquipmentCreate.html",
			getAccess: function (userAccessService) {
				return userAccessService.getAccess(
					Vgr.systemPermissions.CrudEquipmentAllocation,
					null,
					Vgr.constants.featureToggles.release.collectionRequestDisposal
				);
			},
			newSingleton: true
		})
		.state("collectionRequestDisposalEdit", {
			url: "/gestao-solicitacoes/destinacao/:id",
			templateUrl:
				"views/newAngular/residuesManagement/collectionRequests/disposals/collectionRequestDisposalEdit.html",
			getAccess: function (userAccessService) {
				return userAccessService.getAccess(
					Vgr.systemPermissions.ViewDisposal,
					null,
					Vgr.constants.featureToggles.release.collectionRequestDisposal
				);
			},
			newSingleton: true
		})
		.state("collectionRequestInternalTransferEdit", {
			url: "/gestao-solicitacoes/transferencia-interna/:id",
			templateUrl:
				"views/newAngular/residuesManagement/collectionRequests/internalTransfers/collectionRequestInternalTransferEdit.html",
			getAccess: function (userAccessService) {
				return userAccessService.getAccess(
					Vgr.systemPermissions.ViewInternalTransfer,
					null,
					Vgr.constants.featureToggles.release.collectionRequestInternalTransfer
				);
			},
			newSingleton: true
		})
		.state("collectionRequestEquipmentEdit", {
			url: "/gestao-solicitacoes/equipamento/:id",
			templateUrl:
				"views/newAngular/residuesManagement/collectionRequests/equipments/collectionRequestEquipmentEdit.html",
			getAccess: function (userAccessService) {
				return userAccessService.getAccess(
					Vgr.systemPermissions.EquipmentAllocationView,
					null,
					Vgr.constants.featureToggles.release.collectionRequestDisposal
				);
			},
			newSingleton: true
		})
		.state("collectionRequestList", {
			url: "/gestao-solicitacoes?coleta&tipo",
			templateUrl: "views/newAngular/residuesManagement/collectionRequests/collectionRequestList.html",
			getAccess: function (userAccessService) {
				const hasCollectionRequestDisposalView = userAccessService.hasAccess(
					Vgr.systemPermissions.ViewDisposal,
					null,
					Vgr.constants.featureToggles.release.collectionRequestDisposal
				);
				const hasCollectionRequestEquipmentView = userAccessService.hasAccess(
					Vgr.systemPermissions.EquipmentAllocationView,
					null,
					Vgr.constants.featureToggles.release.collectionRequestDisposal
				);
				const hasCollectionRequestInternalTransferView = userAccessService.hasAccess(
					Vgr.systemPermissions.ViewInternalTransfer,
					null,
					Vgr.constants.featureToggles.release.collectionRequestInternalTransfer
				);

				return hasCollectionRequestDisposalView ||
					hasCollectionRequestEquipmentView ||
					hasCollectionRequestInternalTransferView
					? Vgr.enumerations.userAccess.Enabled
					: Vgr.enumerations.userAccess.Hidden;
			},

			newSingleton: true
		})
		.state("internalGatheringList", {
			url: "/historico-geracao?residuo&nomeResiduo&tab&pendencia",
			templateUrl: "views/newAngular/residuesManagement/storages/list/storageList_template.html",
			newSingleton: true
		})
		.state("internalGatheringEdit", {
			url: "/geracao/:id",
			templateUrl: "views/newAngular/residuesManagement/storages/edit/storageEdit_template.html",
			newSingleton: true
		})
		.state("internalGatheringCreateByModel", {
			url: "/geracao?modelId",
			templateUrl: "views/newAngular/residuesManagement/storages/createByModel/storageCreateByModel_template.html",
			newSingleton: true
		})
		.state("internalGatheringCreate", {
			url: "/geracao",
			templateUrl: "views/newAngular/residuesManagement/storages/create/storageCreate_template.html",
			getAccess: function (userAccessService) {
				return userAccessService.getAccess(Vgr.systemPermissions.CreateAndEditResiduesGeneration);
			},
			newSingleton: true
		})
		.state("destinationNew", {
			url: "/destinacao?modelo&origem",
			templateUrl: "views/destination/destination_template.html",
			newSingleton: false
		})
		.state("disposalFollowup", {
			url: "/acompanhamento-destinacoes",
			templateUrl: "views/destination/followup/destinationFollowup_template.html",
			newSingleton: false
		})
		.state("mtrFollowUp", {
			url: "/acompanhamento-mtrs?mtr",
			templateUrl: "views/newAngular/residuesManagement/disposals/mtrFollowUp/mtrFollowUp.html",
			newSingleton: true
		})
		.state("disposalHistory", {
			url: "/historico-destinacoes",
			templateUrl: "views/newAngular/residuesManagement/disposals/disposalHistory/disposalHistory.html",
			newSingleton: true
		})
		.state("destinationEdit", {
			url: "/destinacao/:id?tab",
			templateUrl: "views/destination/destination_template.html",
			newSingleton: false
		})
		.state("disposalModels", {
			url: "/modelo-destinacoes",
			templateUrl: "views/newAngular/residuesManagement/disposals/disposalModels/disposalModels.html",
			newSingleton: true
		})
		.state("destinationEditModel", {
			url: "/modelo-destinacoes/:id",
			templateUrl: "views/newAngular/residuesManagement/disposals/disposalModels/edit/disposalEditModels.html",
			getAccess: function (userAccessService) {
				return userAccessService.getAccess(Vgr.systemPermissions.CrudDisposalModels);
			},
			newSingleton: true
		})
		.state("destinationCreateModel", {
			url: "/modelo-destinacoes/novo?disposal",
			templateUrl: "views/newAngular/residuesManagement/disposals/disposalModels/create/disposalCreateModels.html",
			getAccess: function (userAccessService) {
				return userAccessService.getAccess(Vgr.systemPermissions.CrudDisposalModels);
			},
			newSingleton: true
		})
		.state("createDisposalFromModel", {
			url: "/modelo-destinacoes/:id/nova-destinacao",
			templateUrl:
				"views/newAngular/residuesManagement/disposals/disposalModels/createDisposal/createDisposalFromModel.html",
			getAccess: function (userAccessService) {
				return userAccessService.getAccess(Vgr.systemPermissions.CreateDisposalFromModelOrCollectionRequest, null);
			},
			newSingleton: true
		})
		.state("createDisposalFromCollectionRequest", {
			url: "/gestao-solicitacoes/:id/nova-destinacao?numeroEquipamento",
			templateUrl:
				"views/newAngular/residuesManagement/disposals/disposalModels/createDisposal/createDisposalFromCollectionRequest.html",
			getAccess: function (userAccessService) {
				return userAccessService.getAccess(Vgr.systemPermissions.CreateDisposalFromModelOrCollectionRequest, null);
			},
			newSingleton: true
		})
		.state("destinatorDisposalManifestList", {
			url: "/acompanhamento-destinador",
			templateUrl: "views/newAngular/residuesManagement/destinator/destinatorMtrList.html",
			noPadding: true,
			getAccess: function (userAccessService) {
				return userAccessService.getAccess(
					Vgr.systemPermissions.DestinatorModuleView,
					Vgr.constants.featureToggles.permission.destinatorModule
				);
			},
			newSingleton: true
		})
		.state("disposalLoads", {
			url: "/importacao-destinacoes",
			templateUrl: "views/newAngular/residuesManagement/disposals/disposalLoads/disposalLoads.html",
			noPadding: true,
			isMaster: true,
			getAccess: function (userAccessService) {
				return getStandardMasterAccess(userAccessService);
			},
			newSingleton: true
		})
		.state("disposal", {
			url: "/destinacao/:id/dados?origem",
			templateUrl: "views/newAngular/residuesManagement/disposals/disposal.html",
			newSingleton: true
		})
		.state("dialogFrame", {
			url: "/destinacao/:id/popups?dialog&transporter",
			templateUrl: "views/newAngular/residuesManagement/disposals/dialogsPage/dialogsPage.html",
			newSingleton: true
		})
		.state("storageList", {
			url: "/listagem-geracoes?residuo&nomeResiduo&tab&pendencia",
			templateUrl: "views/newAngular/residuesManagement/storages/list/storageList_template.html",
			newSingleton: true
		})
		.state("storageCreate", {
			url: "/criar-geracao",
			templateUrl: "views/newAngular/residuesManagement/storages/create/storageCreate_template.html",
			getAccess: function (userAccessService) {
				return userAccessService.getAccess(Vgr.systemPermissions.CreateAndEditResiduesGeneration);
			},
			newSingleton: true
		})
		.state("storageListInternalTransfer", {
			url: "/movimentacao-interna/:id/listagem-geracoes",
			templateUrl:
				"views/newAngular/residuesManagement/storages/listInternalTransfer/storageListInternalTransfer_template.html",
			newSingleton: true
		})
		.state("storageEdit", {
			url: "/editar-geracao/:id",
			templateUrl: "views/newAngular/residuesManagement/storages/edit/storageEdit_template.html",
			newSingleton: true
		})
		.state("storageStore", {
			url: "/armazenar-geracao/:id",
			templateUrl: "views/newAngular/residuesManagement/storages/store/storageStore_template.html",
			newSingleton: true
		})
		.state("webhookEvent", {
			url: "/eventos-webhook",
			templateUrl: "views/newAngular/webhooks/webhookEvent.html",
			newSingleton: true
		})
		.state("apiRequestEvent", {
			url: "/eventos-requisicoes",
			templateUrl: "views/newAngular/webhooks/apiRequestEvent.html",
			newSingleton: true
		})
		.state("webhookConfig", {
			url: "/configurar-webhook",
			templateUrl: "views/newAngular/webhooks/webhookConfig.html",
			newSingleton: true
		})
		.state("vertownNotificationList", {
			url: "/master/comunicados-vertown",
			templateUrl: "views/newAngular/master/vertownNotifications/list/vertownNotificationList.html",
			isMaster: true,
			getAccess: function (userAccessService) {
				return userAccessService.getAccess(Vgr.systemPermissions.MasterViewClientData);
			},
			newSingleton: true
		})
		.state("vertownNotificationCreate", {
			url: "/master/comunicados-vertown/novo",
			templateUrl: "views/newAngular/master/vertownNotifications/create/vertownNotificationCreate.html",
			isMaster: true,
			getAccess: function (userAccessService) {
				return userAccessService.getAccess(Vgr.systemPermissions.MasterCreateEditDeleteNotifications);
			},
			newSingleton: true
		})
		.state("vertownNotificationEdit", {
			url: "/master/comunicados-vertown/:id",
			templateUrl: "views/newAngular/master/vertownNotifications/edit/vertownNotificationEdit.html",
			isMaster: true,
			getAccess: function (userAccessService) {
				return userAccessService.getAccess(Vgr.systemPermissions.MasterViewClientData);
			},
			newSingleton: true
		});

	applicationInsightsServiceProvider.configure({
		instrumentationKey: Vgr.constants.applicationInsightsKey,
		applicationName: "PortalAngularJs"
	});
	// this is in order to work on ie. Without this, ajax calls behave unexpectedly
	if (!$httpProvider.defaults.headers.get) {
		$httpProvider.defaults.headers.common = {};
	}
	$httpProvider.defaults.headers.common["Cache-Control"] = "no-cache";
	$httpProvider.defaults.headers.common.Pragma = "no-cache";
	$httpProvider.defaults.headers.common["If-Modified-Since"] = "Sat, 01 Jan 2000 00:00:00 GMT";

	$httpProvider.interceptors.push("responseErrorInterceptor");
	$httpProvider.interceptors.push("cultureHeaderInjector");
	$httpProvider.interceptors.push("clientVersionHeaderInjector");
	$httpProvider.interceptors.push("organizationHeaderInjector");
	$httpProvider.interceptors.push("vgrProtectedResourceInterceptor");

	NotificationProvider.setOptions({
		positionX: "left",
		positionY: "bottom",
		priority: 1000,
		maxCount: 1
	});

	function getStandardMasterAccess(userAccessService) {
		const hasAccess =
			userAccessService.hasAccess(Vgr.systemPermissions.MasterViewClientData) ||
			userAccessService.hasAccess(Vgr.systemPermissions.MasterCreateEditClientData);

		return hasAccess ? Vgr.enumerations.userAccess.Enabled : Vgr.enumerations.userAccess.Hidden;
	}

	// PGRS é liberado para o staff master que executa PGRS ou para organizações que contrataram o módulo.
	// Mesma regra aplicada na montagem do menu (menu_directive.js).
	function getPgrsAccess(userAccessService, featureAccessService) {
		const hasMasterPgrsPermission = userAccessService.hasAccess(Vgr.systemPermissions.MasterExecutePgrs);

		return hasMasterPgrsPermission || featureAccessService.hasPGRSModule()
			? Vgr.enumerations.userAccess.Enabled
			: Vgr.enumerations.userAccess.Hidden;
	}

	// A integração RAPP IBAMA exige a feature da organização (não feature toggle) mais a permissão de
	// declarações do usuário: ViewDeclarations para as telas de consulta, IntegrateDeclarations para as
	// que criam integração. Mesma regra aplicada na montagem do menu (menu_directive.js) e no backend
	// (IbamaRappPermissionCheck.HasViewAccess / HasIntegrationAccess).
	function getIbamaRappIntegrationViewAccess(userAccessService, featureAccessService) {
		return featureAccessService.hasIbamaRappIntegrationFeature() &&
			userAccessService.hasAccess(Vgr.systemPermissions.ViewDeclarations)
			? Vgr.enumerations.userAccess.Enabled
			: Vgr.enumerations.userAccess.Hidden;
	}

	function getIbamaRappIntegrationCreateAccess(userAccessService, featureAccessService) {
		return featureAccessService.hasIbamaRappIntegrationFeature() &&
			userAccessService.hasAccess(Vgr.systemPermissions.IntegrateDeclarations)
			? Vgr.enumerations.userAccess.Enabled
			: Vgr.enumerations.userAccess.Hidden;
	}

	$provide.decorator("mdAutocompleteDirective", mdAutoCompleteDirectiveOverride);

	mdAutoCompleteDirectiveOverride.$inject = ["$delegate"];

	function mdAutoCompleteDirectiveOverride($delegate) {
		const directive = $delegate[0];
		// need to append to base compile function
		const compile = directive.compile;

		// add our custom attribute to the directive's scope
		angular.extend(directive.scope, {
			menuContainerClass: "@?mdMenuContainerClass"
		});

		// recompile directive and add our class to the virtual repeat container
		directive.compile = function (element, attr) {
			const template = compile.apply(this, arguments);
			const menuContainerClass = attr.mdMenuContainerClass ? attr.mdMenuContainerClass : "";
			const menuContainer = element.find("md-virtual-repeat-container");

			menuContainer.addClass(menuContainerClass);

			// recompile the template
			return function () {
				template.apply(this, arguments);
			};
		};

		return $delegate;
	}

	$provide.decorator("$q", [
		"$delegate",
		function ($delegate) {
			const $q = $delegate;

			// Extention for q
			$q.allSettled =
				$q.allSettled ||
				function (promises) {
					const deferred = $q.defer();
					if (angular.isArray(promises)) {
						const states = [];
						const results = [];
						let didAPromiseFail = false;
						if (promises.length === 0) {
							deferred.resolve(results);
							return deferred.promise;
						}

						// First create an array for all promises with their state
						angular.forEach(promises, function (promise, key) {
							states[key] = false;
						});

						// Helper to check if all states are finished
						const checkStates = function (states, results, deferred, failed) {
							let allFinished = true;
							angular.forEach(states, function (state, key) {
								if (!state) {
									allFinished = false;
								}
							});
							if (allFinished) {
								if (failed) {
									deferred.reject(results);
								} else {
									deferred.resolve(results);
								}
							}
						};

						// Loop through the promises
						// a second loop to be sure that checkStates is called when all states are set to false first
						angular.forEach(promises, function (promise, key) {
							$q.when(promise).then(
								function (result) {
									states[key] = true;
									results[key] = result;
									checkStates(states, results, deferred, didAPromiseFail);
								},
								function (reason) {
									states[key] = true;
									results[key] = reason;
									didAPromiseFail = true;
									checkStates(states, results, deferred, didAPromiseFail);
								}
							);
						});
					} else {
						throw "allSettled can only handle an array of promises (for now)";
					}

					return deferred.promise;
				};

			return $q;
		}
	]);
}

angular
	.module("vgresiduos")
	.config([
		"$stateProvider",
		"$urlRouterProvider",
		"$locationProvider",
		"$httpProvider",
		"NotificationProvider",
		"$provide",
		"applicationInsightsServiceProvider",
		config
	])
	.run([
		"$rootScope",
		"$state",
		"accountService",
		"userAccessService",
		"menuService",
		"featureAccessService",
		"clientVersionService",
		function (
			$rootScope,
			$state,
			accountService,
			userAccessService,
			menuService,
			featureAccessService,
			clientVersionService
		) {
			"use strict";

			clientVersionService.start();

			$rootScope.$on("$stateChangeError", function () {
				console.log("$stateChangeError - fired when an error occurs during transition.");
			});

			$rootScope.$on("$stateChangeStart", function (event, toState, toParams, fromState, fromParams) {
				$rootScope.$broadcast(Vgr.constants.evtStartLoadingPage);

				$rootScope.$state = $state;
				const isLoggedInIdentityServer = accountService.isLoggedInIdp();

				$rootScope.paddingOnView = !toState.noPadding;
				$rootScope.contentNavBar = false;
				$rootScope.onlyContent = false;

				if (toState.redirectTo) {
					$state.go(toState.redirectTo);
					event.preventDefault();
					return;
				}

				if (clientVersionService.reloadOnNavigationIfPending($state.href(toState, toParams, { absolute: true }))) {
					event.preventDefault();
					return;
				}

				if (toState.forceLogout && isLoggedInIdentityServer) {
					accountService.logout();
				}

				if (toState.name == "loginResponse") {
					// commented. Error on login sso. This was added in case user with sso is deactivated, but not working properly. Fix.
					// if (!isLoggedInIdentityServer) {
					//     accountService.goToLogin(null, true);
					//     event.preventDefault();
					//     return;
					// }

					$rootScope.loginWithExternalIdentityProvider = true;
				}

				if (!toState.newSingleton) {
					$rootScope.$broadcast("REDIRECT_FRAME_SINGLETON", { route: Vgr.constants.IframeSingletonBlankPage });
				}

				if (!isLoggedInIdentityServer) {
					const sso = getUrlParameter("idp");
					if (toState.name == "home" && sso) {
						//permite logar automaticamente quando é SSO e chama o endereço da home com o parametro de idp
						accountService.loginWithFederatedIdentity(sso);
						event.preventDefault();
						return;
					}
					if (!toState.noAuth) {
						accountService.goToLogin();
						event.preventDefault();
						return;
					}
				}

				if (isLoggedInIdentityServer) {
					if (
						accountService.isLogoutInProgress() ||
						toState.name == "completeSignup" ||
						toState.name == "changeTemporaryPassword"
					) {
						return;
					}

					//logou na AWS cognito mas nao logou o usuario na plataforma
					if (
						toState.name != "afterLoginIdentityProvider" &&
						(!accountService.getLoggedAccount() || !accountService.getCurrentClient())
					) {
						$state.go("afterLoginIdentityProvider");
						event.preventDefault();
						return;
					}

					if (toState.noAuth) {
						accountService.goHome();
						event.preventDefault();
						return;
					}

					if (toState.getAccess) {
						const access = toState.getAccess(userAccessService, featureAccessService, accountService);
						if (access == Vgr.enumerations.userAccess.Disabled || access == Vgr.enumerations.userAccess.Hidden) {
							accountService.goHome(true);
							event.preventDefault();
							return;
						}
					}

					if (!menuService.organizationHasAccessToState(toState)) {
						accountService.goHome(true);
						event.preventDefault();
						return;
					}
				}
			});

			function getUrlParameter(param, dummyPath) {
				const sPageURL = dummyPath || window.location.search.substring(1);
				const sURLVariables = sPageURL.split(/[&||?]/);
				let res;
				for (let i = 0; i < sURLVariables.length; i += 1) {
					const paramName = sURLVariables[i],
						sParameterName = (paramName || "").split("=");

					if (sParameterName[0] === param) {
						res = sParameterName[1];
					}
				}

				return res;
			}

			$rootScope.$on("$stateChangeSuccess", function (event, state) {
				$rootScope.$broadcast(Vgr.constants.evtFinishLoadingPage);
			});
		}
	]);
